// extracted by mini-css-extract-plugin
module.exports = {"section-link":"section-link-m__section-link__2i0X3","text":"section-link-m__text__ku3jX"};